
<template>
    <div class="chat__header">
      <!-- <pre>{{ chatData }}</pre> -->
        <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
            <div class="relative flex mr-4">
                <feather-icon icon="MenuIcon" class="mr-4 cursor-pointer" v-if="isSidebarCollapsed" @click.stop="$emit('openContactsSidebar')" />
                <vs-avatar class="m-0 border-2 border-solid border-white" size="40px" :src="userDetails.user_pic" @click.stop="$emit('showProfileSidebar', userId)" />
                <div class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(false)"></div>
            </div>
            <h6>{{ userDetails.name }}</h6>
            <vs-spacer></vs-spacer>
            <!-- <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current': isPinnedLocal}, 'w-6', 'h-6']" @click.stop="isPinnedLocal = !isPinnedLocal"></feather-icon> -->
        </vs-navbar>
    </div>
</template>

<script>
import { fetchChatHistory } from '@/api/message'
import {mapGetters} from 'vuex'
import {EventBus} from './mixin/EventBus'
import {messageMixin} from './mixin/messageMixin'

export default {
  data () {
    return {
      fetchChatData:[],
      chatData:[]
    }
  },
  mixins:[messageMixin],
  props: {
    userId: {
      // type: Number,
      required: true
    },
    isPinnedProp: {
      type: Boolean,
      required: true
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['ChatRelatedTo', 'Threads']),
    userDetails () {
      let user = null
      this.Threads.forEach(item => {
        if (item.user_id === this.userId) {
          user =  item
        }
      })
      // return this.$store.getters['chat/contact'](this.userId)
      return user
    },
    getStatusColor () {
      return (isActiveUser) => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    }
  },
  methods: {
    getUserStatus (isActiveUser) {
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.userDetails.status
    },
    async fetChatHistory () {
      try {

        // 
        // 

        let user_id = null
        if (this.activeTab === 0) {
          user_id = this.$store.state.message.Admin_Active_Thread
        } else if (this.activeTab === 1) {
          user_id = this.$store.state.message.Client_Active_Thread
        }
        const payload = {
          another_user_id : user_id,
          from_user_type : 'User',
          group_id : null,
          last_id : null,
          is_client_message_type: this.ChatRelatedTo,
          customer_id:localStorage.getItem('customer_id')
        }
        const { data } = await fetchChatHistory(payload)
        // 
        
        this.fetchChatData = data.data
      } catch (e) {
        
      }
    }
  },
  mounted () {
    // Listen for the singleChatClicked event and its payload.
    // EventBus.$on('singleChatClicked', (chatData) => {
    //   
    //   this.chatData = chatData.result
    //   
    // })
  }
}

</script>

